var App = App || {};

App.Alerts = (function ($) {
    'use strict';

    function Init() {
        var alerts = $("#Alerts").find(".alert");

        alerts.each(function (index, alert) {
            var $alert = $(alert),
                $alertCollapse = $alert.find(".btn-collapse"),
                guid = $alert.data("guid"),
                cookieName = `ZAGInteractive_Alert_${guid}`;

            $alertCollapse.on("click", function () {
                var $collapseButton = $(this);

                ToggleCollapse($alert, $collapseButton, cookieName);
            });

            $alert.on("closed.bs.alert", function () {
                App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            })
        });
    }

    function ToggleCollapse($alert, $collapseButton, cookieName) {
        if ($collapseButton.attr("aria-expanded") == "false") {
            $collapseButton.attr("aria-expanded", "true");

            $alert
                .removeClass("collapsed")
                .attr("role", "alert");

            App.Cookies.setItem(cookieName, "Collapsable", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
        else {
            $collapseButton.attr("aria-expanded", "false");

            $alert
                .addClass("collapsed")
                .attr("role", null);

            App.Cookies.setItem(cookieName, "Collapsed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
    }

    return {
        Init: Init
    };

})(jQuery);